import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainFooter from "../../module/footer/main_footer";
import MainNavBar from "../../module/nav_bar/main_nav_bar";
import "./main_page.css";
import slide_1 from "../../img/carousel_1.jpg";
import slide_2 from "../../img/carousel_2.jpg";
import slide_3 from "../../img/carousel_3.jpg";
import KakaoMap from "../../module/kakao_map/kakao_map";
import MainHeader from "../../module/header/main_header";
import FixedBtn from "../../module/fixed_btn/fixed_btn";
import LoginBtn from "../../module/login_btn/login_btn";

function MainPage() {
  const [slideNum, setSlideNum] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      slideNum < 2 ? setSlideNum(slideNum + 1) : setSlideNum(0);
    }, 3000);
    return () => clearTimeout(timer);
  }, [slideNum]);

  return (
    <div className="main_page">
      <header>
        <MainHeader />
      </header>
      <nav className="main_nav">
        <MainNavBar />
      </nav>
      <main>
        <div className="carousel">
          <div
            className="slide_container"
            style={{ transform: `translateX(-${slideNum}00%)` }}
          >
            <div className="slide" id="first">
              <img src={slide_1}></img>
            </div>
            <div className="slide" id="second">
              <img src={slide_2}></img>
            </div>
            <div className="slide" id="third">
              <img src={slide_3}></img>
            </div>
          </div>
          <div className="intro_container">
            <span>
              <span className="strong">사랑</span>과{" "}
              <span className="strong">겸손</span>으로
              <br />
              <span className="strong">섬김</span>을 실천하는 기관,
              <br />
              <span className="strong">전문적인 소양</span>을 갖춘 기관,
              <br />
              <span className="strong">투명</span>하고{" "}
              <span className="strong">깨끗</span>한 기관,
              <br />
              <span className="strong">시니어사랑 방문요양센터</span>
            </span>
          </div>
        </div>
        <div className="shortcut_buttons">
          <div className="button_container">
            <Link to="/service/define">
              <div className="shortcut_button" id="info">
                <span className="material-symbols-outlined">heart_plus</span>
                <div className="button_detail">방문요양이란?</div>
              </div>
            </Link>
            <Link to="/procedure">
              <div className="shortcut_button" id="procedure">
                <span className="material-symbols-outlined">inventory</span>
                <div className="button_detail">이용자격 및 절차</div>
              </div>
            </Link>
            <Link to="/charge/table">
              <div className="shortcut_button" id="charge">
                <span className="material-symbols-outlined">payments</span>
                <div className="button_detail">이용요금</div>
              </div>
            </Link>
            <div className="line_break" id="shortcut_btn"></div>
            <Link to="/service/detail">
              <div className="shortcut_button" id="service">
                <span className="material-symbols-outlined">
                  volunteer_activism
                </span>
                <div className="button_detail">서비스 내용</div>
              </div>
            </Link>
            <Link to="/service/matching">
              <div className="shortcut_button" id="service">
                <span className="material-symbols-outlined">group_add</span>
                <div className="button_detail">요양사 매칭</div>
              </div>
            </Link>
            <Link to="/community/qna">
              <div className="shortcut_button" id="service">
                <span className="material-symbols-outlined">
                  contact_support
                </span>
                <div className="button_detail">자주 묻는 질문</div>
              </div>
            </Link>
          </div>
        </div>
        <div className="map_container">
          <div className="counsel_info">
            <div className="counsel_title">Contact Us</div>
            <div className="counsel_detail">
              <div id="call">24시간 요양센터 상담 전화</div>
              <div id="number">Tel. 041-575-7651</div>
              <div id="number">Mobile. 010-4569-7651</div>
              <div id="address">
                <div>오시는 길</div>
                <div>
                  충남 천안시 서북구{" "}
                  <div className="line_break" id="address_detail" hidden></div>
                  월봉7길 49 2층 223호
                </div>
              </div>
            </div>
          </div>
          <KakaoMap />
        </div>
      </main>
      <FixedBtn />
      <footer>
        <MainFooter />
        {/* <LoginBtn /> */}
      </footer>
    </div>
  );
}

export default MainPage;
